module.exports = __webpack_public_path__ + "static/img/7.b4aaa6b7.jpg";